module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h13"
  }, [_c('span', {
    staticClass: "th11"
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("Special thanks to Nessa L. Warin for editing and mentorship, "), _c('span', {
    staticClass: "t2"
  }, [_vm._v("and to the Dreamspinner team for all their tremendous work.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_vm._v("And as always, to my husband, who is my miracle ")]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_vm._v("every single day.")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ac69130","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/002.vue
// module id = 57
// module chunks = 0